import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { uniqueId } from '../../utils/DomUtils.js';
import { CheckboxPresentation } from './CheckboxPresentation.js';

var CheckboxWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckboxWrapper, _React$Component);
  var _super = _createSuper(CheckboxWrapper);
  function CheckboxWrapper(props) {
    var _this;
    _classCallCheck(this, CheckboxWrapper);
    _this = _super.call(this, props);
    _this.uniqueId = uniqueId("lsg--checkbox");
    _this.state = {
      hasKeyboardFocus: false,
      hasMouseHover: false
    };
    return _this;
  }
  _createClass(CheckboxWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        hasKeyboardFocus = _this$state.hasKeyboardFocus,
        hasMouseHover = _this$state.hasMouseHover;
      return /*#__PURE__*/React.createElement(CheckboxPresentation, Object.assign({}, this.props, {
        id: this.props.id || this.uniqueId,
        hasKeyboardFocus: hasKeyboardFocus,
        onKeyboardFocusChange: function onKeyboardFocusChange(newFocus) {
          return _this2.setState({
            hasKeyboardFocus: newFocus
          });
        },
        hasMouseHover: hasMouseHover,
        onMouseHoverChange: function onMouseHoverChange(newHover) {
          return _this2.setState({
            hasMouseHover: newHover
          });
        }
      }));
    }
  }]);
  return CheckboxWrapper;
}(React.Component);

export { CheckboxWrapper };
